import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SeoCreate } from '../../services';

export const fetchSeoCreate = createAsyncThunk(
    'seoCreate/fetchSeoCreate',
    async ({ file, title, slug, description, keywords, canonical, author }) => {
        const response = await SeoCreate(file, title, slug, description, keywords, canonical, author)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const seoCreateSlice = createSlice({
    name: 'seoCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoCreateSlice.reducer;
